// extracted by mini-css-extract-plugin
export default {"link":"XET5l4zk1Os898521zrv","active":"MsvCOZIvGXJC8rZE1TEe"};